// extracted by mini-css-extract-plugin
export var addButton = "_5y-d";
export var bullets = "_5y-e";
export var compact = "_5y-2";
export var container = "_5y-j";
export var extendedWarrantyModal = "_5y-f";
export var learn = "_5y-l";
export var learnMore = "_5y-g";
export var offeringOption = "_5y-3";
export var offeringPrice = "_5y-8";
export var offeringSubtitle = "_5y-7";
export var offeringTitle = "_5y-6";
export var offeringsContainer = "_5y-0";
export var pdpTilesBackground = "_5y-n";
export var plan = "_5y-m";
export var regular = "_5y-1";
export var remove = "_5y-k";
export var seeDetailsIcon = "_5y-i";
export var seeDetailsLink = "_5y-h";
export var selectedOption = "_5y-4";
export var shieldIcon = "_5y-b";
export var shieldIconCompact = "_5y-c";
export var subtitle = "_5y-a";
export var title = "_5y-9";
export var unselectedOption = "_5y-5";